import React, { useRef, useState } from "react";
import { RCCButton, RCCGrid, RCCHookToast, RCCSelectOptionsCard, RCCServicesApi } from "react-common-components";
import { IRefComponentSelectOptionsCard } from "react-common-components/dist/components/SelectOptionsCard/interface";
import SortableHandle from "src/components/Sortable/Handle";
import SortableItem from "src/components/Sortable/Item";
import Title from "src/components/Title";
import { useTranslation } from "src/context/Translations/context";
import { standardErrorMessages } from "src/utils/errors";
import dashboardTemplates, { textBadge } from "../dashboardTemplates";
import DragCard from "../DragCard";
import { FormatDashboard, IDashboardTemplate } from "../interface";
import { EditContent } from "./styles";

interface IEditTemplateContent{
    closeEditTemplateContent: () => void;
    dashboardId: number;
    onCallbackAddLineToDashboard: (data: any) => void;
}

const EditTemplateContent: React.FC<IEditTemplateContent> = ({
	closeEditTemplateContent,
	dashboardId,
	onCallbackAddLineToDashboard
}) => {
	const { translate } = useTranslation();
	const { addToast } = RCCHookToast();
	const numberColumnsRef = useRef<IRefComponentSelectOptionsCard>(null);
	const [buttonLoadingState, setButtonLoadingState] = useState(false);
    
	const [filterList, setFilterList] = useState<FormatDashboard | undefined>(FormatDashboard.ACTIONS);

	const addLineToDashboard = async () => {
		const columnsNumber = numberColumnsRef.current?.value || 1;
		try{
			setButtonLoadingState(true);
			const response = await RCCServicesApi.postRequest({
				method: "Dashboard/InsertLine",
				body: {
					id: dashboardId,
					columnsNumber
				}
			});
			
			addToast({
				color: "green",
				description: translate("Linha adicionada com sucesso"),
				title: translate("Sucesso")
			});

			onCallbackAddLineToDashboard(response.data);
			
			setButtonLoadingState(false);
		}catch(err){
			setButtonLoadingState(false);
			standardErrorMessages(err, translate("Erro ao adicionar linha no dashboard"), addToast);
		}
	};

	const filterTemplates = (formatDashboard: FormatDashboard) => {
		const situationToUpdate: FormatDashboard | undefined = formatDashboard;
		
		if(filterList && filterList === formatDashboard)
			return;

		setFilterList(situationToUpdate);
	};

	return(<EditContent>
		<RCCButton 
			color="blue"
			onClick={closeEditTemplateContent}
			style={{
				position: "absolute",
				top: "4px",
				right: 0
			}}
		>{translate("Concluir edição")}</RCCButton>
		<Title size="md" color="purple">Widgets</Title>
		<hr />
		<Title size="sm" color="purple">{translate("Linha")}</Title>
		<Title size="xs" color="purple">{translate("As linhas são usadas como grade. Após inserida a linha, você pode arrastar os elementos que você quer para compor seu dashboard para dentro dela")}.</Title>
		<RCCGrid container item alignItems="center" justifyContent="space-between" style={{ padding: "0 4px" }}>
			<RCCSelectOptionsCard 
				defaultValue="1"
				options={[{
					label: "1",
					value: "1"
				},{
					label: "2",
					value: "2"
				},{
					label: "3",
					value: "3"
				},{
					label: "4",
					value: "4"
				}]}
				label={translate("Número de colunas")}
				ref={numberColumnsRef}
				styleInline=">div{ width: fit-content; }"
			/>
			<RCCButton color="purple" icon={{ name: "plus" }} size="md" layout="isRounded" onClick={addLineToDashboard} loading={buttonLoadingState} />
		</RCCGrid>
		<hr />
		<RCCGrid container item>
			{Array.from(new Set(dashboardTemplates.map((x) => x.format))).map((dashboardTemplate: FormatDashboard) => (
				<RCCButton 
					onClick={() => filterTemplates(dashboardTemplate)} 
					color="grey" key={dashboardTemplate.toString()} 
					styleInline={filterList && filterList !== dashboardTemplate ? "filter: brightness(0.5);" : ""}
				>{textBadge(dashboardTemplate, translate)}</RCCButton>
			))}
		</RCCGrid>
		{dashboardTemplates.filter((x) => (filterList !== undefined && x.format === filterList) || filterList === undefined ).map((dashboardTemplate: IDashboardTemplate) => (
			<SortableItem id={dashboardTemplate.id.toString()} key={dashboardTemplate.id}>
				<SortableHandle>
					<DragCard 
						dashboardTemplate={dashboardTemplate}
					/>
				</SortableHandle>
			</SortableItem>
		))}
	</EditContent>);};

export default EditTemplateContent;
